import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGrinning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 46,
	height: 46,
	viewBox: "0 0 46 46",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23 45.4C35.3712 45.4 45.4 35.3712 45.4 23C45.4 10.6288 35.3712 0.599998 23 0.599998C10.6288 0.599998 0.600006 10.6288 0.600006 23C0.600006 35.3712 10.6288 45.4 23 45.4Z",
			fill: "url(#paint0_radial_5_1772)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M23 45.4C35.3712 45.4 45.4 35.3712 45.4 23C45.4 10.6288 35.3712 0.599998 23 0.599998C10.6288 0.599998 0.600006 10.6288 0.600006 23C0.600006 35.3712 10.6288 45.4 23 45.4Z",
			fill: "url(#paint1_radial_5_1772)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.072 11.3937C18.072 10.4977 17.1031 9.93507 15.4361 9.93507C14.0191 9.93507 10.904 10.7165 8.75775 13.4774C8.36185 13.9879 8.96612 14.2692 9.36203 13.9358C10.6852 12.8106 14.2171 11.3728 16.978 11.675C18.0824 11.8 18.072 11.3937 18.072 11.3937Z",
			fill: "url(#paint2_linear_5_1772)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6862 22.2808C16.8773 22.2808 17.8428 20.8208 17.8428 19.0198C17.8428 17.2188 16.8773 15.7587 15.6862 15.7587C14.4951 15.7587 13.5295 17.2188 13.5295 19.0198C13.5295 20.8208 14.4951 22.2808 15.6862 22.2808Z",
			fill: "url(#paint3_radial_5_1772)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6862 16.8528C16.6135 16.8528 17.4157 17.655 17.8428 18.8532C17.8116 17.0924 16.8635 15.6755 15.6862 15.6755C14.5089 15.6755 13.5608 17.0924 13.5295 18.8532C13.9567 17.6654 14.7589 16.8528 15.6862 16.8528Z",
			fill: "url(#paint4_linear_5_1772)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.9279 11.3935C27.9279 10.4975 28.8969 9.93486 30.5638 9.93486C31.9808 9.93486 35.0959 10.7163 37.2422 13.4772C37.6381 13.9877 37.0338 14.269 36.6379 13.9356C35.3147 12.8104 31.7828 11.3726 29.0219 11.6748C27.9175 11.7998 27.9279 11.3935 27.9279 11.3935Z",
			fill: "url(#paint5_linear_5_1772)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.3139 22.2813C31.505 22.2813 32.4706 20.8213 32.4706 19.0203C32.4706 17.2192 31.505 15.7592 30.3139 15.7592C29.1229 15.7592 28.1573 17.2192 28.1573 19.0203C28.1573 20.8213 29.1229 22.2813 30.3139 22.2813Z",
			fill: "url(#paint6_radial_5_1772)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.3139 16.8529C29.3867 16.8529 28.5845 17.6552 28.1573 18.8533C28.1885 17.0926 29.1366 15.6756 30.3139 15.6756C31.4912 15.6756 32.4393 17.0926 32.4706 18.8533C32.0434 17.6656 31.2412 16.8529 30.3139 16.8529Z",
			fill: "url(#paint7_linear_5_1772)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.1278 26.7922C37.9611 26.7297 37.7736 26.7193 37.6069 26.7714C32.8769 28.1258 27.9697 28.803 23.0104 28.803C18.0512 28.803 13.1336 28.1154 8.41398 26.7714C8.23686 26.7193 8.05975 26.7297 7.89305 26.7922C7.38254 27.0006 6.56989 27.7716 7.643 30.72V30.7305C9.22663 34.502 13.4253 41.1282 23 41.1282C32.5539 41.1282 36.7526 34.4916 38.3779 30.7305C39.4406 27.7716 38.6384 27.0006 38.1278 26.7922Z",
			fill: "url(#paint8_radial_5_1772)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.0002 40.0759C26.9697 40.0759 29.9494 38.857 32.179 37.19C29.7306 36.0856 26.7092 35.3667 23.0002 35.3667C19.2911 35.3667 16.2698 36.096 13.8214 37.2108C16.051 38.857 19.0307 40.0759 23.0002 40.0759Z",
			fill: "url(#paint9_radial_5_1772)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.8256 26.7298C37.7943 26.7298 37.7631 26.7298 37.7214 26.7402C32.9497 28.1155 28.0009 28.8135 22.9895 28.8135C17.9782 28.8135 13.0293 28.1155 8.25759 26.7402C8.22634 26.7298 8.19508 26.7298 8.15341 26.7298C7.83043 26.761 6.28848 27.084 7.61164 30.7305V30.7409C8.25759 32.2621 9.33071 34.252 11.0081 36.0753C9.4349 34.2103 11.3728 33.1789 14.8213 33.5956C18.2699 34.0124 22.9895 34.0228 22.9895 34.0228C22.9895 34.0228 27.6987 34.0124 31.1577 33.5956C34.6063 33.1789 36.5441 34.2103 34.9709 36.0753C36.6483 34.252 37.7214 32.2621 38.3674 30.7409V30.7305C39.6905 27.0736 38.1486 26.7506 37.8256 26.7298Z",
			fill: "url(#paint10_linear_5_1772)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.1689 31.8557C36.4817 31.5744 37.4714 30.4804 37.5965 29.1364L37.7215 27.8237C32.9498 29.1677 28.0009 29.8553 23 29.8553C17.9991 29.8553 13.0502 29.1677 8.2785 27.8237L8.40353 29.1364C8.52855 30.47 9.51832 31.564 10.8311 31.8557C14.811 32.7204 18.8951 33.1476 23 33.1476C27.1049 33.1476 31.189 32.71 35.1689 31.8557Z",
			fill: "url(#paint11_radial_5_1772)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_5_1772",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(18.5928 13.922) scale(27.0227)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFDF30" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFB82E"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_5_1772",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(18.5928 13.922) scale(21.26)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFE95F" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFBB47",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_5_1772",
				x1: 13.3485,
				y1: 12.8954,
				x2: 13.3485,
				y2: 10.535,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#7A4400"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint3_radial_5_1772",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(15.0325 19.0957) rotate(73.8539) scale(3.16495 2.04768)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#7A4400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_5_1772",
				x1: 15.6867,
				y1: 15.7351,
				x2: 15.6867,
				y2: 18.7751,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#512D00"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_5_1772",
				x1: 32.6514,
				y1: 12.8952,
				x2: 32.6514,
				y2: 10.5348,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#7A4400"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint6_radial_5_1772",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(29.6598 19.0967) rotate(73.8539) scale(3.16495 2.04767)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#7A4400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_5_1772",
				x1: 30.3134,
				y1: 15.7353,
				x2: 30.3134,
				y2: 18.7753,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#512D00"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint8_radial_5_1772",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(23 33.9329) scale(12.3397 12.3397)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#7A4400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint9_radial_5_1772",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(23.1849 38.2737) scale(10.227 3.09161)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .2479,
					stopColor: "#FF0000"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C10000"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint10_linear_5_1772",
				x1: 38.7228,
				y1: 31.3963,
				x2: 7.46818,
				y2: 31.3963,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .00132565,
						stopColor: "#3C2200"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "#512D00"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#3C2200"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint11_radial_5_1772",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(23 30.4905) scale(27.0614 27.0614)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "white"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#A8BBBD"
				})]
			})
		] })
	]
});
export { SvgGrinning as ReactComponent };
